import { IAppState } from '../../common/state';
import { ISeoLinksTab } from '../../types/seoTabsLinks';

export function getSeoTabsLinks(state: IAppState): ISeoLinksTab[] {
  return state.seoTabsLinks || [];
}
